"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterTags = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("./constants");
const types_1 = require("./types");
const head_1 = __importDefault(require("next/head"));
/**
 * TwitterTags component
 * @param androidAppUrl - The URL of the Android app
 * @param description - The description of the website
 * @param imageUrl - The URL of the image to be used in the Twitter card
 * @param iosAppUrl - The URL of the iOS app
 * @param title - The title of the website
 * @param twitterCard - The type of Twitter card to be used
 * @description - The component wraps the `meta` tags inside `Head` from `next/head`.
 * Therefore it cannot be included in an other `Head` tag in the parent component.
 * here is an example of integration:
 * ```tsx
 * <Head>
 *   <meta name="a name" />
 * </Head>
 * <TwitterTags description="your favorite eventbrite app" />
 * <Component {...pageProps} />;
 * ```
 */
const TwitterTags = ({ androidAppUrl, description, imageUrl, iosAppUrl, title = "Eventbrite", twitterCard = types_1.TwitterCard.Summary, }) => (react_1.default.createElement(head_1.default, null,
    react_1.default.createElement("meta", { key: "twitter:card", name: "twitter:card", content: twitterCard }),
    react_1.default.createElement("meta", { key: "twitter:site", name: "twitter:site", content: "@eventbrite" }),
    react_1.default.createElement("meta", { key: "twitter:title", name: "twitter:title", content: title }),
    description && react_1.default.createElement("meta", { key: "twitter:description", name: "twitter:description", content: description }),
    react_1.default.createElement("meta", { key: "twitter:image", name: "twitter:image", content: imageUrl ? imageUrl : constants_1.OPEN_GRAPH_DEFAULT_IMAGE_PATH }),
    react_1.default.createElement("meta", { key: "twitter:app:name:iphone", name: "twitter:app:name:iphone", content: "Eventbrite" }),
    iosAppUrl && react_1.default.createElement("meta", { key: "twitter:app:url:iphone", name: "twitter:app:url:iphone", content: iosAppUrl }),
    react_1.default.createElement("meta", { key: "twitter:app:id:iphone", name: "twitter:app:id:iphone", content: "487922291" }),
    react_1.default.createElement("meta", { key: "twitter:app:name:googleplay", name: "twitter:app:name:googleplay", content: "Eventbrite" }),
    androidAppUrl && (react_1.default.createElement("meta", { key: "twitter:app:url:googleplay", name: "twitter:app:url:googleplay", content: androidAppUrl })),
    react_1.default.createElement("meta", { key: "twitter:app:id:googleplay", name: "twitter:app:id:googleplay", content: "com.eventbrite.attendee" })));
exports.TwitterTags = TwitterTags;
//# sourceMappingURL=TwitterTags.js.map